// extracted by mini-css-extract-plugin
export default {"avatar":"mkl573"};